import Image from 'next/image';
import React from 'react';

const IntegrationsTechMachineLearning = () => {
    return (
        <div className="section-py !pb-0 dark:bg-black">
            <div className="container lg:container mx-auto">
                <div className="row grid lg:grid-cols-12">
                    <div className="lg:col-span-10 pb-10">
                        <h2 className="mb-4 dark:text-white" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                            Integrations & Tech Stack
                        </h2>
                        <p className='mb-0' data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                            We leverage a comprehensive set of tools and platforms to build scalable and efficient machine learning solutions. Our technology stack is carefully selected to support the entire ML lifecycle from data preparation and model development to production deployment and continuous monitoring. This curated ecosystem enables rapid experimentation, enterprise-grade reliability, and seamless integration with your existing infrastructure, delivering predictive intelligence that drives business outcomes.
                        </p>
                    </div>
                </div>
                 <div className="row grid xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-3 mb-[30px]">
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/ai-agent/svg/ic-orchestration-framework.svg"
                                width={36}
                                height={36}
                                alt="ML Frameworks"
                            />
                        </div>
                        <p className="fw-700 dark:text-white mb-1">ML Frameworks</p>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                            Build production-ready models with industry-leading frameworks. Leverage TensorFlow for deep learning, PyTorch for research flexibility, Scikit-learn for traditional ML, and XGBoost for boosting performance.
                        </p>
                    </div>
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                        <div className="voice-generator-box mb-3">
                            <Image src="/img/ai-agent/svg/ic-mcp-protocol.svg" width={36} height={36} alt="Cloud ML Platforms" />
                        </div>
                        <p className="fw-700 dark:text-white mb-1">Cloud ML Platforms</p>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                            Accelerate model development and deployment on enterprise cloud infrastructure. Deploy with AWS SageMaker, Azure ML, Google Vertex AI, and Databricks for unified analytics and scalable MLOps.
                        </p>
                    </div>
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/ai-agent/svg/ic-llm-integration.svg"
                                width={36}
                                height={36}
                                alt="MLOps Tools"
                            />
                        </div>
                        <p className="fw-700 dark:text-white mb-1">MLOps Tools</p>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                           Streamline ML lifecycle management with comprehensive tracking and orchestration. Implement MLflow, Kubeflow, DVC, and Weights & Biases for experiment tracking, versioning, and collaborative workflows.
                        </p>
                    </div>
                </div>
                <div className="row grid xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-3 mb-[30px]">
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/ai-agent/svg/ic-vector-database.svg"
                                width={36}
                                height={36}
                                alt="Data Processing Tools"
                            />
                        </div>
                        <p className="fw-700 dark:text-white mb-1">Data Processing Tools</p>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                            Handle large-scale data transformation and computation efficiently. Process with Pandas, NumPy, Apache Spark, Dask, and Polars for high-performance data manipulation and distributed computing.
                        </p>
                    </div>
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/ai-agent/svg/ic-rpa-tools.svg"
                                width={36}
                                height={36}
                                alt="Model Serving Tools"
                            />
                        </div>
                        <p className="fw-700 dark:text-white mb-1">Model Serving Tools</p>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                            Deploy models to production with enterprise-grade serving infrastructure. Serve with TensorFlow Serving, TorchServe, FastAPI, BentoML, and Seldon Core for scalable, low-latency predictions.
                        </p>
                    </div>
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/ai-agent/svg/ic-minitoring-&-observation.svg"
                                width={36}
                                height={36}
                                alt="Monitoring Tools"
                            />
                        </div>
                        <p className="fw-700 dark:text-white mb-1">Monitoring Tools</p>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                            Ensure model reliability with continuous performance tracking and observability. Monitor with Arize, Grafana, Prometheus, and Fiddler AI for drift detection, explainability, and production health metrics.
                        </p>
                    </div>
                </div>              
            </div>
        </div>
    );
};

export default IntegrationsTechMachineLearning;
